module.exports = __webpack_public_path__ + "img/arrow2.046586f9.svg";